<script>
  import SubPageLayout from 'src/pc/layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: SubPageLayout,
    components: {
      DisplayContainer
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .sub-page-layout .inner .ad_wrap.mid img {
    width: 250px !important;
    height: 250px !important;
  }
  .sub-page-layout .articles {
    margin-top: 0 !important;
  }
  .sub-page-layout .articles.margin_top {
    margin-top: 10px !important;
  }
  .sub-page-layout.poll .articles.margin_top {
    margin-top: 0 !important;
    border-top: 0;
  }
  .sub-page-layout .articles .left {
    width: 100% !important;
    display: block !important;
  }
  .sub-page-layout .articles .right {
    display: none !important;
  }
  .sub-page-layout .articles .title {
    width: 100% !important;
    margin: 15px 0 !important;
  }
  .sub-page-layout .articles h3 {
    font-size: 20px !important;
    line-height: 1.6em !important;
    letter-spacing: -0.01em;
  }
  .sub-page-layout .articles h3:before {
    width: 28px !important;
    height: 30px !important;
    margin-right: 8px !important;
  }
  .sub-page-layout .articles h3 a span {
    font-size: 14px;
    line-height: 2.6em;
    margin-left: 3px;
  }
  .sub-page-layout .articles .title .dropdown_wrap {
    padding: 5px 0 15px;
  }
  .sub-page-layout .articles .lst > li {
    width: 100% !important;
    padding: 15px 120px 15px 0 !important;
    min-height: 110px !important;
    margin-bottom: 0 !important;
    border-bottom: 1px solid #e5e5e5 !important;
    border-right: 0 !important;
    position: relative !important;
  }
  .sub-page-layout .articles .lst > li:nth-child(3n+1) {
    width: 100% !important;
    padding: 15px 120px 15px 0 !important;
  }
  .sub-page-layout .articles .lst > li:nth-child(3n+3) {
    width: 100% !important;
    padding: 15px 120px 15px 0 !important;
  }
  .sub-page-layout .articles .lst_more {
    font-size: 16px;
  }
  .sub-page-layout .articles .lst_more:after {
    width: 8px;
    height: 8px;
    right: 25px;
  }

  /** todo 서브 중간 배너 **/
  .sub-page-layout .articles .lst > li.has_banner {
    min-height: 440px !important;
  }
  .sub-page-layout .articles .lst li .banner {
    width: calc(100vw - 40px) !important;
    padding: 25px 0 40px !important;
    margin-bottom: 15px !important;
    text-align: center !important;
    border-bottom: 1px solid #e5e5e5 !important;
  }
  .sub-page-layout .articles .lst .display-container img {
    width: 250px !important;
    height: 250px !important;
  }
  /** 서브 중간 배너 **/
	
	.ad_wall {
		display: none !important;
	}
</style>
